import { render } from "./Casco.vue?vue&type=template&id=069fc0fa"
import script from "./Casco.vue?vue&type=script&lang=js"
export * from "./Casco.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__